<template>
  <div
    class="justify-content-center d-flex bg-white px-12 py-3 rounded"
    style="width: 400px">
    <img src="/assets/icon/v2-reminder.svg" />
    <div class="ms-3 d-flex flex-column justify-content-around">
      <div class="d-flex font-size-16 fw-semibold">
        <div>{{ title }}</div>
      </div>
      <div class="d-flex">
        <img src="/assets/icon/icon-alarm-v2.svg" />
        <div class="ms-1 font-14">{{ description }}</div>
      </div>
      <span
        v-if="!conversation.group 
        || (conversation.group && message.id.uidFrom === '0')
        "
        class="text-blue600 ms-1 pointer"
        @click="$emit('editTopic')">
        <u>Chỉnh sửa nhắc hẹn</u>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatECard",
  props: ["href", "title", "description", "message", "conversation"],
};
</script>

<style scoped>
</style>